import React from 'react';
import {
  PreviewKpis, PreviewPage, PreviewPanel, PreviewTable, PreviewTabs,
} from '../../components/access-denied/preview/PreviewParts';

/** Prévia falsa do financeiro para a tela de bloqueio (dados de exemplo fixos). */
const FinancialLockedPreview = () => (
  <PreviewPage>
    <PreviewTabs labels={['Transações', 'Categorias']} />
    <PreviewKpis
      items={[
        { label: 'Entradas', value: 'R$ 0.000,00' },
        { label: 'Saídas', value: 'R$ 0.000,00' },
        { label: 'Saldo', value: 'R$ 0.000,00' },
      ]}
    />
    <PreviewPanel title="Transações">
      <PreviewTable
        columns={['Data', 'Descrição', 'Categoria', 'Valor']}
        rows={[
          ['01/01', 'Sessão de exemplo', 'Atendimentos', 'R$ 000,00'],
          ['02/01', 'Aluguel de exemplo', 'Despesas fixas', 'R$ 000,00'],
          ['03/01', 'Pacote de exemplo', 'Atendimentos', 'R$ 000,00'],
          ['04/01', 'Material de exemplo', 'Insumos', 'R$ 000,00'],
        ]}
      />
    </PreviewPanel>
  </PreviewPage>
);

export default FinancialLockedPreview;
